import { gql } from '@apollo/client'
import React from 'react'

import { checklistsClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useChecklistState = () => React.useContext(Context)
export const useChecklist = () => useChecklistState()?.checklist

const QUERY = gql`
  query Checklist($id: ID, $fromTemplates: Boolean, $filter: ChecklistFilter) {
    checklist(id: $id, fromTemplates: $fromTemplates, filter: $filter) {
      id
      allowReview
      usages
      requireCheckin
      emailNotificationEnabled
      name
      typeId
      enabled
      questions {
        id
        name
        reference
        parentReference
        displayConditions
        description
        documents {
          id
          src
          type
          description
        }
        ordination
        categoryOrdination
        required
        allowNull
        photosEnabled
        photosRequired
        notesEnabled
        notesRequired
        defaultValue
        minPhotos
        nonComplianceConditions
        photosFromGallery
        private
        data
        options {
          id
          name
          reference
          ordination
        }
        category {
          id
          name
        }
        typeName
        type {
          id
        }
      }
    }
  }
`

const ChecklistLoader = ({ children }) => {
  const { id, fromTemplates, ignoreProject } = useModalData()

  const { data, ...state } = useQuery(QUERY, {
    variables: {
      id,
      fromTemplates: fromTemplates || false,
      filter: { includeDisabled: true, includeDeleted: true, ignoreSegments: true, ignoreProject }
    },
    client: checklistsClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={{ ...data, fromTemplates }}>{children}</Provider>
    </StatePresenter>
  )
}

export default ChecklistLoader
